import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { setMissingDetailsRedirect } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import clsx from "clsx";
import React, { useState } from "react";
import { IFooterAddCustomerProps } from "../../customer_profile_interface";

const FooterAddCustomerComponent: React.FC<IFooterAddCustomerProps> = ({
  formHook,
  submitButtonTitle,
  onSubmit,
  layoutFor,
  setNavTo,
  ...props
}) => {
  const { isCustomerCreationInProgress, isCustomerPetCreationInProgress } = useAppSelector((state) => state.loading);
  const dispatch = useAppDispatch();
  const [bookBlockedError, setBookBlockedError] = useState<string | null>(null);

  const INACTIVE_PET_MESSAGE = "This pet is inactive/deceased. Set the pet status to Active to continue.";

  const isPetInactive = () => formHook.getValues("is_pet_active") !== true;
  // Plain Save is only blocked inside the booking (missing-details) flow — a
  // standalone create/update should still be able to save an inactive/deceased pet.
  const isBookingFlow = props?.addons?.case === "BOOKING_MISSING_DETAILS";

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setBookBlockedError(null);
    if (isBookingFlow && isPetInactive()) {
      event.preventDefault();
      setBookBlockedError(INACTIVE_PET_MESSAGE);
      return;
    }
    const isValid = await formHook.trigger();
    if (isValid) {
      setNavTo("CP");
      formHook.handleSubmit(onSubmit);
    }
  };

  const handleSaveAndBook = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setBookBlockedError(null);
    // Save & Book always leads to booking slots, which is invalid for an inactive/deceased pet.
    if (isPetInactive()) {
      event.preventDefault();
      setBookBlockedError(INACTIVE_PET_MESSAGE);
      return;
    }
    const isValid = await formHook.trigger();
    if (isValid) {
      setNavTo("SLOTS");
      formHook.handleSubmit(onSubmit);
      dispatch(setMissingDetailsRedirect(true));
    }
  };
  const submiteButtonTitle = submitButtonTitle && submitButtonTitle !== "" ? submitButtonTitle : "Save";

  return (
    <div className="">
      {!isCustomerCreationInProgress || !isCustomerPetCreationInProgress ? (
        <div className="flex gap-4 p-3">
          <button
            onClick={handleSubmit}
            className={clsx(
              "py-1.5 sm:py-2 px-3 sm:px-4 rounded-lg bg-[var(--color-primary)] text-white text-xs font-medium hover:opacity-90 flex items-center gap-2",
              props?.submitButtonClassName,
            )}
          >
            {submiteButtonTitle}
          </button>
          {layoutFor === "BOTH" && (
            <button
              onClick={handleSaveAndBook}
              className="heading border bg-[#193a6a] opacity-100 px-[23px] py-2 rounded-md border-[rgba(128,141,160,0.2)]"
            >
              <span className="saveBookAppointment font-[Poppins,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,'Helvetica_Neue',Arial] text-xs font-medium text-white text-left tracking-[0.27px]">
                Save & Book Appointment
              </span>
            </button>
          )}
        </div>
      ) : (
        <button
          disabled
          type="button"
          className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800 inline-flex items-center"
        >
          Creating customer with pet...
        </button>
      )}
      {bookBlockedError && (
        <p className="px-3 pb-2 text-xs font-medium text-red-500 text-left" role="alert">
          {bookBlockedError}
        </p>
      )}
    </div>
  );
};

export default FooterAddCustomerComponent;
